import Axios from "../../api/Axios";
const BASE_URL = "SalesDiscountAllocation/";

export const EndpointSalesDiscountAllocation = {
    GetAllPriceListData: "GetAllPriceListData",
    GetAllDiscountData: "GetAllDiscountData",
    GetAllSalesDiscountAllocationData: "GetAllSalesDiscountAllocationData",
    GetCustDetailsData: "GetCustDetailsData",
    GetFilteredCustomerData: "GetFilteredCustomerData",
    DeleteCustDetailsData: "DeleteCustDetailsData",
    SaveData: "SaveData",
    DeleteHeaderData: "DeleteHeaderData"
};
export const createAPIEndpointSalesDiscountAllocation = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
